// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Message, MessageT, verifyMessage } from "./message";

export class ValuedMessage implements flatbuffers.IUnpackableObject<ValuedMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ValuedMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsValuedMessage(bb: flatbuffers.ByteBuffer, obj?: ValuedMessage): ValuedMessage {
    return (obj || new ValuedMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsValuedMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ValuedMessage,
  ): ValuedMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ValuedMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  msg(obj?: Message): Message | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Message()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startValuedMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMsg(builder: flatbuffers.Builder, msgOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, msgOffset, 0);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(1, +active, +false);
  }

  static endValuedMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // msg
    return offset;
  }

  static finishValuedMessageBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset);
  }

  static finishSizePrefixedValuedMessageBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset, undefined, true);
  }

  static createValuedMessage(
    builder: flatbuffers.Builder,
    msgOffset: flatbuffers.Offset,
    active: boolean,
  ): flatbuffers.Offset {
    ValuedMessage.startValuedMessage(builder);
    ValuedMessage.addMsg(builder, msgOffset);
    ValuedMessage.addActive(builder, active);
    return ValuedMessage.endValuedMessage(builder);
  }

  unpack(): ValuedMessageT {
    return new ValuedMessageT(this.msg() !== null ? this.msg()!.unpack() : null, this.active());
  }

  unpackTo(_o: ValuedMessageT): void {
    _o.msg = this.msg() !== null ? this.msg()!.unpack() : null;
    _o.active = this.active();
  }

  unpackFields(...fields: string[]): ValuedMessageT {
    const t = new ValuedMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("msg")) {
      t.msg = this.msg() !== null ? this.msg()!.unpack() : null;
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    return t;
  }
}

export class ValuedMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public msg: MessageT | null = null,
    public active: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.msg === null || this.msg === undefined) {
      throw new Error('Required field "msg" is not set');
    }
    const msg = this.msg !== null ? this.msg!.pack(builder) : 0;

    return ValuedMessage.createValuedMessage(builder, msg, this.active);
  }

  clone(): ValuedMessageT {
    const obj = new ValuedMessageT();
    obj.msg = this.msg !== null ? this.msg!.clone() : null;
    obj.active = this.active;
    return obj;
  }

  equals(other: ValuedMessageT): boolean {
    if (this.msg !== null && other.msg !== null) {
      if (!this.msg!.equals(other.msg!)) return false;
    } else if (this.msg !== other.msg) return false;
    if (this.active !== other.active) return false;
    return true;
  }
}

export function verifyValuedMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyMessage(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "msg");
    verifier.checkScalarField(tablePos, 6, 1);
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsValuedMessage(buf: DataView, opts?: flatbuffers.VerifierOptions): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyValuedMessage(verifier, tablePos);
}
